import React from 'react';
import { MONTHS } from './calculations/monthlyNeedCalculations.js';

const NEED_COLOR = '#c9832e';
const COLLECT_COLOR = '#0a4d5c';

/** Graphique en barres groupées : besoin vs collecté, mois par mois. */
export const ComparisonBarChart = ({ need, collected }) => {
  const w = 848, h = 240, pad = 32, groupGap = 14;
  const max = Math.max(...need, ...collected, 1);
  const plotH = h - pad * 2 - 20;
  const groupW = (w - pad * 2 - groupGap * 11) / 12;
  const barW = groupW / 2 - 2;

  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" height={h}>
      <line x1={pad} y1={h - pad} x2={w - pad} y2={h - pad} stroke="var(--color-surface-highest, #e0e2eb)" />
      {Array.from({ length: 12 }).map((_, i) => {
        const gx = pad + i * (groupW + groupGap);
        const bh1 = (need[i] / max) * plotH, bh2 = (collected[i] / max) * plotH;
        const y1 = h - pad - bh1, y2 = h - pad - bh2;
        return (
          <g key={i}>
            <rect x={gx} y={y1} width={barW} height={bh1} rx="3" fill={NEED_COLOR} />
            <rect x={gx + barW + 3} y={y2} width={barW} height={bh2} rx="3" fill={COLLECT_COLOR} />
            <text x={gx + groupW / 2} y={h - pad + 16} fontSize="11" textAnchor="middle" fill="var(--color-on-surface-var, #5c6270)">{MONTHS[i]}</text>
          </g>
        );
      })}
    </svg>
  );
};

/** Courbes cumulées sur l'année : besoin et collecte cumulés mois après mois. */
export const CumulativeLineChart = ({ need, collected }) => {
  const w = 848, h = 240, padL = 34, padR = 20, padT = 20, padB = 30;
  let cn = 0, cc = 0;
  const needCum = need.map(v => (cn += v));
  const colCum = collected.map(v => (cc += v));
  const max = Math.max(...needCum, ...colCum, 1);
  const plotW = w - padL - padR, plotH = h - padT - padB;
  const pt = (i, val) => [padL + (i / 11) * plotW, padT + plotH - (val / max) * plotH];

  const pathFor = (arr) => arr.map((v, i) => { const [x, y] = pt(i, v); return `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`; }).join(' ');
  const dotsFor = (arr, color) => arr.map((v, i) => {
    const [x, y] = pt(i, v);
    return <circle key={i} cx={x.toFixed(1)} cy={y.toFixed(1)} r="3" fill={color} />;
  });

  return (
    <svg viewBox={`0 0 ${w} ${h}`} width="100%" height={h}>
      <line x1={padL} y1={padT} x2={padL} y2={h - padB} stroke="var(--color-surface-highest, #e0e2eb)" />
      <line x1={padL} y1={h - padB} x2={w - padR} y2={h - padB} stroke="var(--color-surface-highest, #e0e2eb)" />
      <path d={pathFor(needCum)} fill="none" stroke={NEED_COLOR} strokeWidth="2.5" />
      <path d={pathFor(colCum)} fill="none" stroke={COLLECT_COLOR} strokeWidth="2.5" />
      {dotsFor(needCum, NEED_COLOR)}
      {dotsFor(colCum, COLLECT_COLOR)}
      {MONTHS.map((m, i) => {
        const [x] = pt(i, 0);
        return <text key={i} x={x} y={h - 8} fontSize="11" textAnchor="middle" fill="var(--color-on-surface-var, #5c6270)">{m}</text>;
      })}
    </svg>
  );
};

export const ChartLegend = ({ needLabel = 'Besoin', collectLabel = 'Collecté' }) => (
  <div className="rw-legend">
    <span className="rw-legend-item"><span className="rw-swatch" style={{ background: NEED_COLOR }} />{needLabel}</span>
    <span className="rw-legend-item"><span className="rw-swatch" style={{ background: COLLECT_COLOR }} />{collectLabel}</span>
  </div>
);
